import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { authCodeFlowConfig } from './auth.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public get getToken(): string {
    return this.oauthService.getAccessToken();
  }

  public get getAuthHeader(): string {
    return this.oauthService.authorizationHeader();
  }

  constructor(
    private oauthService: OAuthService
  ) { }

  isAuthenticated() {
    const hasValidAccessToken = this.oauthService.hasValidAccessToken();
    const hasValidIdToken = this.oauthService.hasValidIdToken();

    console.log('hasValidAccessToken: ' + hasValidAccessToken, 'hasValidIdToken: ' + hasValidIdToken);
    const token = this.oauthService.getAccessToken();
    console.log('AccessToken: ' + token);
    const tokenId = this.oauthService.getIdToken();
    console.log('IdToken: ' + tokenId);

    return hasValidAccessToken && hasValidIdToken;
  }

  getAccessToken(): string {
    return this.oauthService.getAccessToken();
  }

  async bootstrapAuthService(): Promise<any> {
    console.log(authCodeFlowConfig.redirectUri);
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.setupAutomaticSilentRefresh({},"access_token",false);
    await this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  async tryLogin() {
    console.log(authCodeFlowConfig.redirectUri);
    this.oauthService.initCodeFlow();
  }

  async tryLoginFlow() {
    this.oauthService.initLoginFlow();
  }

  async logout() {
    this.oauthService.logOut();
  }

  async revokeAndLogout() {
    this.oauthService.revokeTokenAndLogout();
  }

  async getIdentityClaims(): Promise<any> {
    //return this.oauthService.loadUserProfile();
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      console.error('identity claims not present');
      return null;
    }
    return claims;
    // console.log(claims['name']);
    // console.log(claims['mail']);
  }

}
